import { IErrorResponseType } from "../../constants/commonTypes";
import { OtpState } from "../reducers/otpReducer";

export const GENERATE_OTP = "GENERATE_OTP"
export const GENERATE_OTP_REQUEST = "GENERATE_OTP_REQUEST"
export const GENERATE_OTP_FAILURE = "GENERATE_OTP_FAILURE"
export const GENERATE_OTP_SUCCESS = "GENERATE_OTP_SUCCESS"

export const VERIFY_OTP = "VERIFY_OTP"
export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST"
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE"
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS"


export interface GenerateOtpAction {
  type: typeof GENERATE_OTP;
}

export interface GenerateOtpRequestAction {
  type: typeof GENERATE_OTP_REQUEST;
}

export interface GenerateOtpSuccessAction {
  type: typeof GENERATE_OTP_SUCCESS;
  response: OtpState;
}

export interface GenerateOtpFailureAction {
  type: typeof GENERATE_OTP_FAILURE;
  error: Error | string | null | IErrorResponseType;
}
export interface VerifyOtpAction {
  type: typeof VERIFY_OTP;
  request: object;
}

export interface VerifyOtpRequestAction {
  type: typeof VERIFY_OTP_REQUEST;
}

export interface VerifyOtpSuccessAction {
  type: typeof VERIFY_OTP_SUCCESS;
  response: OtpState;
}

export interface VerifyOtpFailureAction {
  type: typeof VERIFY_OTP_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export type OtpActions =
  | GenerateOtpAction
  | GenerateOtpRequestAction
  | GenerateOtpSuccessAction
  | GenerateOtpFailureAction
  | VerifyOtpAction
  | VerifyOtpRequestAction
  | VerifyOtpSuccessAction
  | VerifyOtpFailureAction;